export default __webpack_public_path__ + "static/media/loader.dbb22bcf.gif";